var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.html.hover.viewport.noninteractive",modifiers:{"html":true,"hover":true,"viewport":true,"noninteractive":true}}],staticClass:"bi bi-info-circle pointer",attrs:{"title":`<div class='text-left'>
    <b>To apply updates across templates:</b>
    <ol class='pl-3 m-0'>
      <li>Select the destination templates</li>
      <li>Select the ${_vm.actionsText}</li>
      <li>Click Apply</li>
    </ol>
  </div>`}})
}
var staticRenderFns = []

export { render, staticRenderFns }